import { Link } from "react-router-dom";
import { GapCell } from "@/components/catchup/GapCell";

/* One row per truck or part, a column per item of the definition. The first column stays put when the list
   scrolls sideways on a phone. */
export function ChecklistTable({ kind, items, rows, onMark }) {
  const base = kind === "trucks" ? "/donors/" : "/parts/";
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-200" data-testid={`checklist-table-${kind}`}>
      <table className="min-w-full text-sm">
        <thead className="bg-slate-50 text-[10px] font-bold uppercase tracking-wider text-slate-500">
          <tr>
            <th className="sticky left-0 z-10 bg-slate-50 text-left px-3 py-2 min-w-[9rem]">{kind === "trucks" ? "Truck" : "Part"}</th>
            <th className="px-2 py-2 text-center">Missing</th>
            {items.map((it) => <th key={it.key} className="px-2 py-2 text-left whitespace-nowrap" title={it.rule}>{it.label}</th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((r) => (
            <tr key={r.id} data-testid={`checklist-row-${r.id}`} data-back-row className="hover:bg-slate-50/60 transition-colors">
              <td className="sticky left-0 z-10 bg-white px-3 py-2 align-top">
                <Link to={`${base}${r.id}`} className="font-mono font-bold text-[13px] text-[#B01E28] hover:underline">{r.stock_number || r.short_code}</Link>
                <div className="text-[11px] text-slate-500 truncate max-w-[11rem]">{r.title}</div>
              </td>
              <td className="px-2 py-2 text-center align-top">
                <span data-testid={`checklist-missing-${r.id}`}
                  className={`inline-block min-w-[1.75rem] rounded-full px-1.5 py-0.5 text-xs font-black tabular-nums ${r.missing ? "bg-[#B01E28] text-white" : "bg-emerald-100 text-emerald-800"}`}>
                  {r.missing || "✓"}
                </span>
              </td>
              {items.map((it) => (
                <td key={it.key} className="px-2 py-2 align-top min-w-[6.5rem]">
                  <GapCell cell={r.cells[it.key]} testid={`cell-${r.id}-${it.key}`}
                    onMark={() => onMark({ row: r, item: it.key, cell: r.cells[it.key], mark: r.cells[it.key].mark || r.cells[it.key].can_mark })} />
                </td>
              ))}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={items.length + 2} className="px-3 py-4 text-sm text-slate-500" data-testid="checklist-empty">Nothing is missing here.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
